var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-button',{attrs:{"type":_vm.type},nativeOn:{"click":function($event){return _vm.copyTextToClipboard(_vm.textForCopy)}}},[_vm._t("default",[_vm._v(" Copy ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }